import { getSectionKey } from '../index';

export function transformToString(key, value) {
  return value === true ? key : null;
}

export function transformStringToObject(value) {
  const sectionKey = getSectionKey(value);

  return {
    [sectionKey]: {
      [value]: true,
    },
  };
}
